import { Fun, Pair, mk_widget, nothing, Option } from 'widgets-for-react'
import { List } from 'immutable'
import React from 'react'
import { Breadcrumb } from '../../wordpress/types_and_parser/extra_types.mod'
import { ParsedNode } from '../../wordpress/types_and_parser/types.ext.gen'
import { ContentType } from '../../public_site.main.mod'
import { Breadcrumbs } from './breadcrumbs.mod'
import { page_header } from './page_header.mod'
import { Link } from 'react-router-dom'
import { toRelativeUrl, decodeHTMLEntities } from '../../../helpers'

export const page: Fun<Pair<List<Breadcrumb>, Option<ParsedNode>>, ContentType> = page => blocks => {
  return mk_widget({
    run: o => (
      <>
        <main className={`main main--default`}>
          <div className="main__inner gutter--m">
            <article className={`page page--${page.snd.v.kind == 'r' && page.snd.v.v.type}`}>
              <div className="page__inner">
                <div className='page__content'>
                  {page.snd.v.kind == 'r' &&
                    page.snd.v.v.breadcrumb &&
                    page.snd.v.v.breadcrumb.itemListElement.length > 1 && (
                      <nav className="breadcrumbs">
                        <div className="breadcrumbs__inner container--m grid--gutter">
                          <ul className="breadcrumbs__list">
                            <li className="breadcrumbs__item">
                              <Link to={toRelativeUrl('/')} className="breadcrumbs__link typo--4xs">
                                Home
                              </Link>
                            </li>
                            {page.snd.v.v.breadcrumb.itemListElement.map(item =>
                              item.item['@id'] ? (
                                <li className="breadcrumbs__item">
                                  <Link to={toRelativeUrl(item.item['@id'])} className="breadcrumbs__link typo--4xs">
                                    {decodeHTMLEntities(item.item.name)}
                                  </Link>
                                </li>
                              ) : (
                                <li className="breadcrumbs__item">
                                  <Link
                                    to={toRelativeUrl(window.location.href)}
                                    className="breadcrumbs__link typo--4xs"
                                  >
                                    {decodeHTMLEntities(item.item.name)}
                                  </Link>
                                </li>
                              )
                            )}
                          </ul>
                        </div>
                      </nav>
                    )}
                  {blocks.run(o)}
                </div>
              </div>
            </article>
          </div>
        </main>
      </>
    )
  })
}
